<template>
  <div v-if="show_bottom_inscription_section" class="d-flex justify-center flex-wrap gap mt-4">

    <div class="d-flex justify-center align-center">
      <SportipsButton @onClick="inscrire_groupe" icon="mdi-account-group" chevron action-button mobile-full-width>
        Inscrire un groupe <span v-if="mainStore.module.is_BICENTENAIRE26_module" class="ml-1"> (max 10
          participants)</span>
      </SportipsButton>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {
      error: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
    show_bottom_inscription_section() {

      if (this.$route.query.mode && this.$route.query.mode == 'allow_group') {
        return true;
      }
      if (this.mainStore.module.masquer_bouton_inscrire_groupe) {
        return false;
      }
      if (this.mainStore.inscription_as_admin || this.mainStore?.inscription_vip?.is_valid()) {
        return true;
      }
      if (this.mainStore.module.status == 'avant_ouverture' || this.mainStore.module.status == 'apres_fermeture') {
        return false;
      }
      if (this.mainStore.module.is_complet || this.mainStore.module.allCoursesComplets) {
        return false;
      }
      return true;
    },
  },
  methods: {
    inscrire_groupe() {
      this.mainStore.bookingSystem.groupe.is_inscription_groupe = true;
      this.mainStore.bookingSystem.init();
      this.$router.push({ name: "Inscriptions" });
    },
  },
};
</script>

<style lang="scss" scoped></style>